/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getDCDPO() {
        return HttpService.get(environment.API_DC_DPO);
    },
    createDCDPO(payload) {
        return HttpService.post(environment.API_DC_DPO , payload);
    },
    editDCDPO(payload){
        return HttpService.put(environment.API_DC_DPO , payload);
    }
}